
const style = (theme) => ({
	root: {
		flexGrow: 1
	},
	success: {
		backgroundColor: '#ffffff !important',
		borderLeft: '5px solid #B5D99C',
		color: '#222 !important'
	},
	error: {
		backgroundColor: '#ffffff !important',
		borderLeft: '5px solid #F44336',
		color: '#F44336 !important'
	},
	info: {
		backgroundColor: '#ffffff !important',
		borderLeft: '5px solid #F7C59F',
		color: '#222 !important'
	},
	warning: {
		backgroundColor: '#ffffff !important',
		borderLeft: '5px solid #F7C59F',
		color: '#222 !important'
	},
	icon: {
		fontSize: 14
	},
	iconVariant: {
		opacity: 0.9,
		marginRight: theme.spacing(1)
	},
	message: {
		display: 'flex',
		alignItems: 'center'
	},
	SSO_ALERT: {
		backgroundColor: '#ffffff',
		borderLeft: '5px solid #F44336',
		color: '#F44336'
	}
});

export default style;